import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Additivi',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfame K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralosio',
    [ProductAdditives.Aesculin]: 'Esculina',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Antocianina',
    [ProductAdditives.Antioxidant]: 'Antiossidante',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antiossidante: Acido Ascorbico',
    [ProductAdditives.AntioxidantTocopherols]: 'Antiossidante: Tocoferoli',
    [ProductAdditives.Flavor]: 'Aroma',
    [ProductAdditives.Flavors]: 'Aromi',
    [ProductAdditives.AscorbicAcid]: 'Acido Ascorbico',
    [ProductAdditives.Aspartame]: 'Aspartame',
    [ProductAdditives.OysterSauce]: 'Salsa di Ostriche',
    [ProductAdditives.BakingAid]: 'Ausilio da Forno',
    [ProductAdditives.BakingPowder]: 'Lievito in Polvere',
    [ProductAdditives.BalsamicVinegar]: 'Aceto Balsamico',
    [ProductAdditives.BalsamicCream]: 'Crema Balsamica',
    [ProductAdditives.BasilPesto]: 'Pesto al Basilico',
    [ProductAdditives.BenzoicAcid]: 'Acido Benzoico',
    [ProductAdditives.BetaCarotene]: 'Beta-Carotene',
    [ProductAdditives.Betain]: 'Betaina',
    [ProductAdditives.BeetrootRed]: 'Rosso di Barbabietola',
    [ProductAdditives.Beeswax]: "Cera d'Api",
    [ProductAdditives.Bitters]: 'Amaro',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Sciroppo Blue Curaçao',
    [ProductAdditives.BrandyVinegar]: 'Aceto di Brandy',
    [ProductAdditives.Broth]: 'Brodo',
    [ProductAdditives.Caffeine]: 'Caffeina',
    [ProductAdditives.Calcium]: 'Calcio',
    [ProductAdditives.Caramel]: 'Caramello',
    [ProductAdditives.CaramelColor]: 'Colorante Caramello',
    [ProductAdditives.CaramelE150d]: 'Caramello E150d',
    [ProductAdditives.Carotene]: 'Carotene',
    [ProductAdditives.CayennePepper]: 'Pepe di Cayenna',
    [ProductAdditives.Chili]: 'Peperoncino',
    [ProductAdditives.ChiliDressing]: 'Condimento al Peperoncino',
    [ProductAdditives.ChiliMayonnaise]: 'Maionese al Peperoncino',
    [ProductAdditives.ChiliOil]: 'Olio al Peperoncino',
    [ProductAdditives.Quinine]: 'Chinina',
    [ProductAdditives.Chlorophyll]: 'Clorofilla',
    [ProductAdditives.CitricAcid]: 'Acido Citrico',
    [ProductAdditives.CitrusAcid]: 'Acido di Agrumi',
    [ProductAdditives.CarbonDioxide]: 'Anidride Carbonica (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Salsa Cocktail',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Pasta di Curry',
    [ProductAdditives.CurryPowder]: 'Curry in Polvere',
    [ProductAdditives.CurryCreamSauce]: 'Salsa Crema al Curry',
    [ProductAdditives.Fragrance]: 'Fragranza',
  },
};
